<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="文档编号"><el-input v-model="query.documentCode" size="small" clearable style="width:130px" /></el-form-item>
      <el-form-item label="文档名称"><el-input v-model="query.documentName" size="small" clearable style="width:130px" /></el-form-item>
      <el-form-item label="类型">
        <el-select v-model="query.docType" clearable size="small" style="width:110px">
          <el-option v-for="item in docTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.lifecycleStatus" clearable size="small" style="width:100px">
          <el-option label="草稿" value="draft" />
          <el-option label="已发布" value="released" />
          <el-option label="废止" value="obsolete" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('plm:plmDocument:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('plm:plmDocument:save')" type="primary" size="small" @click="open()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="documentCode" label="文档编号" min-width="120" header-align="center" align="left">
        <template slot-scope="scope">
          <a v-if="isAuth('plm:plmDocument:info')" class="code-link" @click="open(scope.row, true)">{{ scope.row.documentCode }}</a>
          <span v-else>{{ scope.row.documentCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="documentName" label="文档名称" min-width="140" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="materialCode" label="关联物料" min-width="110" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="drawingNo" label="图号" min-width="100" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="docType" label="类型" width="90" header-align="center" align="left">
        <template slot-scope="scope">{{ docTypeLabel(scope.row.docType) }}</template>
      </el-table-column>
      <el-table-column prop="currentRevision" label="当前版本" width="80" header-align="center" align="center" />
      <el-table-column prop="lifecycleStatus" label="状态" width="80" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag :type="lifecycleTag(scope.row.lifecycleStatus)" size="mini">{{ lifecycleLabel(scope.row.lifecycleStatus) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="checkoutBy" label="检出人" width="90" header-align="center" align="left" show-overflow-tooltip>
        <template slot-scope="scope"><span v-if="scope.row.checkoutBy">{{ scope.row.checkoutBy }}</span><span v-else class="text-muted">—</span></template>
      </el-table-column>
      <el-table-column label="操作" width="220" header-align="center" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="isAuth('plm:plmDocument:checkout') && !scope.row.checkoutBy && scope.row.lifecycleStatus !== 'obsolete'" type="text" size="small" @click="handleCheckout(scope.row)">检出</el-button>
          <el-button v-if="isAuth('plm:plmDocument:checkout') && scope.row.checkoutBy" type="text" size="small" @click="handleUndoCheckout(scope.row)">撤销检出</el-button>
          <el-button v-if="isAuth('plm:plmDocument:checkin') && scope.row.checkoutBy" type="text" size="small" @click="openCheckin(scope.row)">检入</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />

    <el-dialog :visible.sync="visible" width="min(720px, calc(100vw - 24px))" :close-on-click-modal="false">
      <template slot="title">
        <div class="doc-dialog-header">
          <span class="doc-dialog-title">{{ dialogTitle }}</span>
          <div v-if="readonly && form.documentId" class="doc-dialog-actions">
            <el-button-group>
              <el-button v-if="(isAuth('plm:plmDocument:release') || isAuth('plm:plmDocument:update') || isAuth('plm:plmDocument:save')) && form.lifecycleStatus === 'draft'" type="primary" size="small" :disabled="!form.revisions || !form.revisions.length" @click="releaseDoc">发布</el-button>
              <el-button v-if="(isAuth('plm:plmDocument:obsolete') || isAuth('plm:plmDocument:update') || isAuth('plm:plmDocument:save')) && form.lifecycleStatus === 'released'" type="warning" size="small" @click="obsoleteDoc">废止</el-button>
              <el-button v-if="isAuth('plm:plmDocument:update') || isAuth('plm:plmDocument:save')" type="primary" size="small" :disabled="form.lifecycleStatus === 'obsolete'" @click="editFromView">修改</el-button>
              <el-button v-if="isAuth('plm:plmDocument:delete') || isAuth('plm:plmDocument:save')" type="danger" size="small" :disabled="form.lifecycleStatus === 'released'" @click="deleteDoc">删除</el-button>
            </el-button-group>
          </div>
        </div>
      </template>
      <el-form ref="dataForm" :model="form" :rules="readonly ? {} : rules" label-width="100px" :disabled="readonly">
        <el-form-item label="文档编号" prop="documentCode"><el-input v-model="form.documentCode" :disabled="!!form.documentId" /></el-form-item>
        <el-form-item label="文档名称" prop="documentName"><el-input v-model="form.documentName" /></el-form-item>
        <el-form-item label="文档类型">
          <el-select v-model="form.docType" style="width:100%">
            <el-option v-for="item in docTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="关联物料">
          <el-input v-model="form.materialCode" readonly placeholder="点击选择">
            <el-button v-if="!readonly" slot="append" @click="materialSelectorVisible = true">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="图号"><el-input v-model="form.drawingNo" /></el-form-item>
        <el-form-item v-if="!readonly && !form.documentId" label="附件">
          <el-upload :show-file-list="true" :limit="1" action="" :http-request="elUploadHttpRequest" :on-success="onCreateUpload" :on-remove="onCreateUploadRemove">
            <el-button size="small" type="primary" plain>上传文件</el-button>
            <div slot="tip" class="el-upload__tip">新建时可上传首版文件（版本 A）</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <div v-if="readonly && form.revisions && form.revisions.length" style="margin-top:12px">
        <div class="section-title">文档版本</div>
        <el-table :data="form.revisions" border size="small" :header-cell-style="headStyle" highlight-current-row @current-change="onRevisionSelect">
          <el-table-column prop="revision" label="版本" width="70" />
          <el-table-column prop="fileName" label="文件名" min-width="140" show-overflow-tooltip />
          <el-table-column prop="releaseStatus" label="发布" width="70">
            <template slot-scope="scope">{{ scope.row.releaseStatus === '1' ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column label="操作" width="90">
            <template slot-scope="scope">
              <el-button v-if="isAuth('plm:plmDocument:release') && scope.row.releaseStatus !== '1'" type="text" size="small" @click="releaseRevision(scope.row)">发布版本</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="section-title" style="margin-top:12px">版本关联
          <el-button v-if="selectedRevision && canEditLinks" type="text" size="mini" @click="addLink">新增</el-button>
          <el-button v-if="selectedRevision && canEditLinks" type="text" size="mini" @click="saveLinks">保存关联</el-button>
        </div>
        <el-table :data="linkRows" border size="small" :header-cell-style="headStyle">
          <el-table-column label="类型" width="110">
            <template slot-scope="s">
              <el-select v-model="s.row.linkType" size="mini" :disabled="!canEditLinks">
                <el-option label="物料" value="material" /><el-option label="BOM行" value="bom" /><el-option label="工艺" value="routing" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="目标" min-width="160">
            <template slot-scope="s">
              <el-input :value="s.row.linkTargetCode || s.row.linkTargetId" readonly size="mini">
                <el-button v-if="canEditLinks && s.row.linkType === 'material'" slot="append" @click="openLinkMaterial(s.$index)">选</el-button>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="角色" width="110">
            <template slot-scope="s">
              <el-select v-model="s.row.linkRole" size="mini" :disabled="!canEditLinks">
                <el-option label="主关联" value="primary" /><el-option label="参考" value="reference" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="60" align="center">
            <template slot-scope="s"><el-button v-if="canEditLinks" type="text" size="mini" @click="linkRows.splice(s.$index, 1)">删</el-button></template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer">
        <el-button @click="visible = false">关闭</el-button>
        <el-button v-if="!readonly" type="primary" @click="save">确定</el-button>
      </span>
    </el-dialog>

    <material-selector :visible.sync="materialSelectorVisible" :multiple="false" @select="onMaterialSelect" />
    <material-selector :visible.sync="linkMaterialSelectorVisible" :multiple="false" @select="onLinkMaterialSelect" />
    <el-dialog title="检入文档" :visible.sync="checkinVisible" width="min(480px, calc(100vw - 24px))" append-to-body>
      <el-form label-width="90px">
        <el-form-item label="变更摘要"><el-input v-model="checkinForm.changeSummary" type="textarea" :rows="2" /></el-form-item>
        <el-form-item label="附件" required>
          <el-upload :show-file-list="true" :limit="1" action="" :http-request="elUploadHttpRequest" :on-success="onCheckinUpload" :on-remove="onCheckinUploadRemove">
            <el-button size="small" type="primary" plain>上传文件</el-button>
          </el-upload>
          <div v-if="checkinForm.fileName" class="el-upload__tip">{{ checkinForm.fileName }}</div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="checkinVisible = false">取消</el-button>
        <el-button type="primary" :loading="checkinSubmitting" @click="submitCheckin">检入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import MaterialSelector from '../../components/MaterialSelector.vue'
import { elUploadHttpRequest } from '../../utils/ossUpload'

const DOC_TYPE_OPTIONS = [
  { value: 'drawing', label: '图纸' },
  { value: 'spec', label: '规格书' },
  { value: 'sop', label: '作业指导' },
  { value: 'inspection', label: '检验标准' },
  { value: 'other', label: '其他' }
]

export default {
  name: 'PlmDocument',
  components: { MaterialSelector },
  data() {
    return {
      docTypeOptions: DOC_TYPE_OPTIONS,
      query: { documentCode: '', documentName: '', docType: '', lifecycleStatus: '' },
      list: [], pageIndex: 1, pageSize: 20, loading: false, visible: false, readonly: false, permCodes: [], form: {},
      materialSelectorVisible: false, linkMaterialSelectorVisible: false, linkPickIndex: -1,
      selectedRevision: null, linkRows: [],
      checkinVisible: false, checkinSubmitting: false, checkinForm: { documentId: '', changeSummary: '', fileName: '', filePath: '', fileSize: 0 },
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' },
      rules: {
        documentCode: [{ required: true, message: '文档编号不能为空', trigger: 'blur' }],
        documentName: [{ required: true, message: '文档名称不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    canEditLinks() {
      return this.form.lifecycleStatus !== 'obsolete' && (this.isAuth('plm:plmDocument:update') || this.isAuth('plm:plmDocument:save'))
    },
    dialogTitle() {
      if (this.readonly) return '查看文档'
      return this.form.documentId ? '修改文档' : '新增文档'
    },
    filtered() {
      return this.list.filter(row => {
        return this.has(row.documentCode, this.query.documentCode)
          && this.has(row.documentName, this.query.documentName)
          && (!this.query.docType || row.docType === this.query.docType)
          && (!this.query.lifecycleStatus || row.lifecycleStatus === this.query.lifecycleStatus)
      })
    },
    total() { return this.filtered.length },
    pageList() { return this.filtered.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) }
  },
  created() { this.loadPerms(); this.load() },
  methods: {
    elUploadHttpRequest,
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    has(value, keyword) {
      const text = String(keyword || '').trim().toLowerCase()
      if (!text) return true
      return String(value || '').toLowerCase().indexOf(text) >= 0
    },
    docTypeLabel(v) {
      const item = DOC_TYPE_OPTIONS.find(o => o.value === v)
      return item ? item.label : (v || '-')
    },
    lifecycleLabel(v) {
      if (v === 'released') return '已发布'
      if (v === 'obsolete') return '废止'
      return '草稿'
    },
    lifecycleTag(v) {
      if (v === 'released') return 'success'
      if (v === 'obsolete') return 'danger'
      return 'info'
    },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.get('/plm/document/list').then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    },
    editFromView() {
      if (this.form.lifecycleStatus === 'obsolete') return
      this.readonly = false
    },
    releaseDoc() {
      this.$confirm('确定发布该文档?', '提示', { type: 'warning' }).then(() => {
        request.post('/plm/document/release', { id: this.form.documentId }).then(() => {
          this.$message.success('发布成功')
          this.$set(this.form, 'lifecycleStatus', 'released')
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    obsoleteDoc() {
      this.$confirm('确定废止该文档?', '提示', { type: 'warning' }).then(() => {
        request.post('/plm/document/obsolete', { id: this.form.documentId }).then(() => {
          this.$message.success('废止成功')
          this.$set(this.form, 'lifecycleStatus', 'obsolete')
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    deleteDoc() {
      if (this.form.lifecycleStatus === 'released') {
        this.$message.warning('已发布文档不可删除，请先废止')
        return
      }
      this.$confirm('确定删除该文档?', '提示', { type: 'warning' }).then(() => {
        request.post('/plm/document/delete', { id: this.form.documentId }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    onMaterialSelect(row) {
      this.form.materialId = row.materialId
      this.form.materialCode = row.materialCode
      this.form.materialName = row.materialName
      this.materialSelectorVisible = false
    },
    onCreateUpload(res) {
      const data = (res && res.data) || {}
      this.form.filePath = data.url || data.filePath || ''
      this.form.fileName = data.fileName || data.name || ''
      this.form.fileSize = data.fileSize || data.size || 0
    },
    onCreateUploadRemove() {
      this.form.filePath = ''
      this.form.fileName = ''
      this.form.fileSize = 0
    },
    onCheckinUpload(res) {
      const data = (res && res.data) || {}
      this.checkinForm.filePath = data.url || data.filePath || ''
      this.checkinForm.fileName = data.fileName || data.name || ''
      this.checkinForm.fileSize = data.fileSize || data.size || 0
    },
    onCheckinUploadRemove() {
      this.checkinForm.filePath = ''
      this.checkinForm.fileName = ''
      this.checkinForm.fileSize = 0
    },
    open(row, readonly) {
      this.readonly = !!readonly
      this.visible = true
      this.selectedRevision = null
      this.linkRows = []
      const blank = () => ({
        documentId: '', documentCode: '', documentName: '', docType: 'other', lifecycleStatus: 'draft',
        materialId: '', materialCode: '', drawingNo: '', remark: '', revisions: [],
        fileName: '', filePath: '', fileSize: 0
      })
      if (!row || !row.documentId) {
        this.form = blank()
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
        return
      }
      request.get('/plm/document/info', { params: { id: row.documentId } }).then(res => {
        this.form = Object.assign(blank(), res.data || row)
        if (this.form.revisions && this.form.revisions.length) {
          this.onRevisionSelect(this.form.revisions[0])
        }
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      }).catch(() => {
        this.form = Object.assign(blank(), row)
        this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      })
    },
    onRevisionSelect(row) {
      this.selectedRevision = row
      this.linkRows = (row && row.links ? row.links : []).map(l => ({ ...l }))
    },
    addLink() {
      if (!this.selectedRevision) return
      this.linkRows.push({ linkType: 'material', linkTargetId: '', linkTargetCode: '', linkRole: 'reference' })
    },
    openLinkMaterial(index) {
      this.linkPickIndex = index
      this.linkMaterialSelectorVisible = true
    },
    onLinkMaterialSelect(row) {
      if (this.linkPickIndex < 0 || !this.linkRows[this.linkPickIndex]) return
      this.$set(this.linkRows[this.linkPickIndex], 'linkTargetId', row.materialId)
      this.$set(this.linkRows[this.linkPickIndex], 'linkTargetCode', row.materialCode)
      this.$set(this.linkRows[this.linkPickIndex], 'linkType', 'material')
      this.linkMaterialSelectorVisible = false
    },
    saveLinks() {
      if (!this.selectedRevision) return
      request.post('/plm/document/link/save', {
        revisionId: this.selectedRevision.revisionId,
        links: this.linkRows.map(l => ({
          linkType: l.linkType,
          linkTargetId: l.linkTargetId,
          linkRole: l.linkRole
        }))
      }).then(() => {
        this.$message.success('关联已保存')
        this.open({ documentId: this.form.documentId }, true)
      }).catch(() => {})
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        request.post('/plm/document/save', {
          documentId: this.form.documentId,
          documentCode: this.form.documentCode,
          documentName: this.form.documentName,
          docType: this.form.docType,
          materialId: this.form.materialId,
          drawingNo: this.form.drawingNo,
          remark: this.form.remark,
          fileName: this.form.fileName,
          filePath: this.form.filePath,
          fileSize: this.form.fileSize
        }).then(() => {
          this.$message.success('保存成功'); this.visible = false; this.load()
        }).catch(() => {})
      })
    },
    handleCheckout(row) {
      request.post('/plm/document/checkout', { documentId: row.documentId }).then(() => { this.$message.success('检出成功'); this.load() }).catch(() => {})
    },
    handleUndoCheckout(row) {
      request.post('/plm/document/undoCheckout', { documentId: row.documentId }).then(() => { this.$message.success('已撤销检出'); this.load() }).catch(() => {})
    },
    openCheckin(row) {
      this.checkinForm = { documentId: row.documentId, changeSummary: '', fileName: '', filePath: '', fileSize: 0 }
      this.checkinVisible = true
    },
    submitCheckin() {
      if (!this.checkinForm.filePath || !this.checkinForm.fileName) {
        this.$message.warning('请先上传检入文件')
        return
      }
      this.checkinSubmitting = true
      request.post('/plm/document/checkin', this.checkinForm).then(() => {
        this.$message.success('检入成功'); this.checkinVisible = false; this.load()
      }).catch(() => {}).finally(() => { this.checkinSubmitting = false })
    },
    releaseRevision(rev) {
      request.post('/plm/document/revisionRelease', { revisionId: rev.revisionId }).then(() => {
        this.$message.success('版本已发布')
        this.open({ documentId: this.form.documentId }, true)
        this.load()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
.text-muted { color: #909399; }
.section-title { font-weight: 600; margin-bottom: 8px; }
</style>
